import { render, staticRenderFns } from "./SearchRecipeContainer.vue?vue&type=template&id=5a6adea9&"
import script from "./SearchRecipeContainer.vue?vue&type=script&lang=js&"
export * from "./SearchRecipeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports